import React, { useEffect } from 'react';
import { FLink } from '@components';
import { useDispatch, useSelector } from 'react-redux';
import { getPerfilInvestimento } from '../../../../store/plan/thunks';
import {
  MUDANCA_PERFIL_ABSOLUTE_PATH,
  QUESTIONARIO_ABSOLUTE_PATH,
  TROCA_DE_PERFIL_ABSOLUTE_PATH,
} from '../../../utils/paths';

export const InvestimentosCard = () => {
  const dispatch = useDispatch();
  const perfilInvestimento = useSelector(
    (state) => state.plan.perfilInvestimento.data
  );

  useEffect(() => {
    dispatch(getPerfilInvestimento());
  }, [dispatch]);

  return (
    <div className="card">
      <div className="card-body">
        <h1 className="ts-20 fw-bold mb-2">Perfil de investimentos</h1>

        {perfilInvestimento?.Label && (
          <div className="row align-items-end d-flex">
            <p className="ts-14 text-muted mb-32">
              O perfil de investimento é definido de acordo com a sua aptidão ao
              risco. Ele é uma escolha que você faz sobre a forma em que será
              realizada a alocação dos seus investimentos.
            </p>
            <h3 className="fw-bold text-orange ts-18">
              Perfil de investimentos atual
            </h3>
            <h3 className="fw-bold text-muted ts-18">
              {perfilInvestimento.Label}
            </h3>
          </div>
        )}
      </div>
      <div className="card-footer">
        <hr className="mb-4" />
        <FLink to={TROCA_DE_PERFIL_ABSOLUTE_PATH} icon>
          Troca de perfil de investimentos
        </FLink>
        <hr className="mb-4 mt-4" />
        <FLink to={MUDANCA_PERFIL_ABSOLUTE_PATH} icon>
          Histórico de alterações
        </FLink>
        <hr className="mb-4 mt-4" />
        <FLink to={QUESTIONARIO_ABSOLUTE_PATH} icon>
          Questionário perfil de investimento
        </FLink>
        <hr className="mb-4 mt-4" />
        {/*
        <p className="ts-14 text-muted mb-32">
          O perfil de investidor é o resultado de uma análise das suas
          características em relação a investimentos, e principalmente ao risco
          envolvido. Simples de ser obtido através de algumas questões, o perfil
          de investidor serve para indicar a carteira de investimentos mais
          adequada para você.
        </p>
        */}
      </div>
    </div>
  );
};
